import { getUserCompanyList } from '@/common/js/util';
export const searchFormColumns = (ctx) => {
  return [
    {
      name: '园区公司',
      prop: 'parkCompanyNo',
      type: 'select',
      options: getUserCompanyList(),
      changeMethod: 'changeMethod',
    },
    {
      name: '园区部门',
      prop: 'parkDepartmentNo',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.query.parkCompanyNo,
    },
    {
      name: '监管单号',
      prop: 'billNo',
      type: 'input',
    },
    {
      name: '监管单状态',
      prop: 'billStatus',
      type: 'select',
      options: ctx.supervisionBillStatusList,
    },
    {
      name: '监管合同号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '创建日期',
      prop: 'billCreateDate',
      type: 'date',
    },
    {
      name: '出质方名称',
      prop: 'pledgorName',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '质权方名称',
      prop: 'pledgeeName',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'relatedName',
      name: '关联方名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
  ];
};

export const baseColumnListDefault = [
  {
    field: 'pledgeeName',
    title: '质权方名称',
    width: 120,
  },
  {
    field: 'pledgorName',
    title: '出质方名称',
    width: 120,
  },
  {
    field: 'relatedName',
    title: '关联方名称',
    width: 120,
  },
  {
    field: 'parkCompanyName',
    title: '园区公司',
    width: 120,
  },
  {
    field: 'billNo',
    title: '监管单号',
    width: 120,
  },
  {
    field: 'billStatus',
    title: '监管单状态',
    width: 120,
  },
  {
    field: 'approvalType',
    title: '审批类型',
    width: 120,
  },
  {
    field: 'quantity',
    title: '重量/数量',
    width: 120,
  },
  {
    field: 'safeWeight',
    title: '安全重量/数量',
    width: 120,
  },
  {
    field: 'billCreateDate',
    title: '监管单创建时间',
    width: 120,
  },
  {
    field: 'contractNo',
    title: '监管合同号',
    width: 120,
  },
  {
    field: 'fullWarehousTime',
    title: '完全入库时间',
    width: 120,
  },
  {
    field: 'fullDeliveryTime',
    title: '完全出库时间',
    width: 120,
  },
  {
    field: 'contractQuantity',
    title: '合同数量/重量',
    width: 120,
  },
  {
    field: 'unit',
    title: '单位',
    width: 120,
  },
  {
    field: 'stockQuantity',
    title: '在库数量/重量',
    width: 120,
  },
  {
    field: 'stockValue',
    title: '在库价值',
    width: 120,
  },
  {
    field: 'operatorName',
    title: '操作人',
    width: 120,
  },
  {
    field: 'remark',
    title: '备注',
    width: 120,
  },
];
